import React, {Fragment, PureComponent} from "react"
import styled from "styled-components"

import Button from "@irati/ui/src/Button"
import authentication from "@irati/auth"
import padding from "@irati/ui/src/global/padding"
import {FormattedMessage} from "@irati/utils/lang"
import tracking from "@irati-tracking/recognition/poll"
import {H3} from "@irati/ui/src/Headings"

import CreatePopup from "../Popup/CreatePoll"

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${padding.base} 0 ${padding.tiny};
`

class PollsTitle extends PureComponent {
  state = {
    showCreate: false
  }

  handleCreate = () => this.setState({
    showCreate: true
  }, () => tracking.startCreatePoll())

  handleAfterExitModal = () => this.setState({
    showCreate: false
  })

  componentDidUpdate() {
    const {showCreate} = this.state

    if (showCreate) {
      this.createPopup.show()
    }
  }

  render() {
    const {showCreate} = this.state
    const canCreatePoll = authentication.apps("recognition.poll.create")
    return (
      <Fragment>
        <HeaderWrapper>
          <H3><FormattedMessage id="recognition.polls.banner.title" /></H3>
          {canCreatePoll &&
            <Button primary onClick={this.handleCreate}>
              <FormattedMessage id="recognition.polls.banner.button" />
            </Button>
          }
        </HeaderWrapper>
        {showCreate &&
          <CreatePopup
            ref={(c) => { this.createPopup = c }}
            onExited={this.handleAfterExitModal} />
        }
      </Fragment>
    )
  }
}

export default PollsTitle
